/**
 * Colonnes explicites pour requêtes Supabase (ECC — éviter select('*')).
 * Aligné sur les migrations dans supabase/migrations/.
 */

/** Plafond pour requêtes liste sans `.single()` (sauf limites métier plus strictes, ex. biblio 80). */
export const SUPABASE_LIST_LIMIT = 500;

export const SELECT_COACH_ROW =
  "id, email, first_name, last_name, phone, avatar_url, role, plan, settings, app_data, created_at, updated_at, last_login_at";

export const SELECT_CLIENTS_LIST =
  "id, coach_id, first_name, last_name, email, phone, birth_date, gender, objective, constraints, disponibilites, preferences, ai_summary, ai_summary_date, notes, status, billing_mode, previous_status, status_changed_at, created_at, updated_at, payload";

export const SELECT_EVENTS_LIST =
  "id, coach_id, client_id, title, date, start_time, end_time, duration, status, is_recurring, recurrence_group_id, location, session_notes, ai_summary, billable, billing_mode, client_product_id, workout_id, created_at, updated_at, payload";

export const SELECT_PRODUCTS_LIST =
  "id, coach_id, name, type, unit_price, pack_size, pack_unit_price, subscription_price, subscription_sessions, is_active, created_at, payload, objective, duration_weeks, includes_assessment, payment_schedule";

export const SELECT_PAYMENTS_LIST =
  "id, coach_id, client_id, event_id, client_product_id, amount, payment_method, status, due_date, paid_at, invoiced_at, notes, created_at";

export const SELECT_CLIENT_PRODUCTS_LIST =
  "id, client_id, product_id, coach_id, status, sessions_remaining, started_at, expires_at, created_at";

export const SELECT_EXERCISE_CATEGORIES_LIST =
  "id, coach_id, name, is_default, position, created_at";

export const SELECT_EXERCISES_ROW =
  "id, coach_id, name, name_en, muscle_groups, equipment, movement_pattern, instructions, video_url, thumbnail_url, is_global, category_id, created_at, updated_at";

export const SELECT_WORKOUT_ROW =
  "id, coach_id, title, objective, duration_target_min, format_tag, difficulty, tags, is_template, template_source_id, program_id, program_position, created_at, updated_at";

export const SELECT_WORKOUT_BLOCK_ROW =
  "id, workout_id, position, label, block_type, block_format, rounds, work_sec, rest_sec, rest_between_rounds_sec, duration_target_min, duration_cap_min, rpe_target, notes, color";

export const SELECT_BLOCK_EXERCISE_ROW =
  "id, block_id, exercise_id, position, sets, reps_min, reps_max, duration_sec, load_type, load_value, tempo, rest_sec, side, notes, actual_load, actual_reps, actual_rpe, actual_notes";

export const SELECT_WORKOUT_NOTES_ROW =
  "id, workout_id, rpe_global, mood, content, highlights, warnings, next_session_ideas, flags, flag_other, created_at";

/** Détail séance + liaisons (fetchWorkout). */
export const SELECT_WORKOUT_FETCH = `${SELECT_WORKOUT_ROW}, workout_clients(client_id, notes, clients(id, first_name, objective, constraints)), workout_notes(${SELECT_WORKOUT_NOTES_ROW})`;

/** Blocs + exercices imbriqués (fetchWorkout). */
export const SELECT_BLOCKS_NESTED = `
${SELECT_WORKOUT_BLOCK_ROW},
block_exercises (
  ${SELECT_BLOCK_EXERCISE_ROW},
  exercise:exercises (${SELECT_EXERCISES_ROW})
)
`
  .replace(/\s+/g, " ")
  .trim();

/** Retour insert/update `block_exercises` avec exercice joint. */
export const SELECT_BLOCK_EXERCISE_WITH_EXERCISE = `${SELECT_BLOCK_EXERCISE_ROW}, exercise:exercises (${SELECT_EXERCISES_ROW})`;
